import type { ReactNode } from "react";
import { formatValue } from "../../../utils/formatValue";

export function renderNameCell(value: unknown, maxLength = 100): ReactNode {
  const rawText = String(formatValue(value));
  const displayText =
    rawText === "-" || rawText.length <= maxLength
      ? rawText
      : `${rawText.slice(0, maxLength)}...`;

  return (
    <span
      title={rawText === "-" ? undefined : rawText}
      className="block max-w-md overflow-hidden text-ellipsis whitespace-nowrap"
    >
      {displayText}
    </span>
  );
}
